import nextI18NextConfig from '../../next-i18next.config.js';
import { dateFormatForUI, formatDate } from '../utils/date';

/**
 * The next-i18next config, plus the custom interpolation formatting.
 *
 * The formatting used to be applied with `i18next.init()` in utils/i18n.ts,
 * against the bare `i18next` package instance — not the one next-i18next builds
 * and renders with. It therefore never took effect: `{{value, uppercase}}` and
 * date interpolations passed through unformatted. Supplying it here means it
 * reaches the instance `appWithTranslation` actually initialises.
 */
const i18nConfig = {
  ...nextI18NextConfig,
  interpolation: {
    alwaysFormat: true,
    escapeValue: false,
    formatSeparator: ',',
    format: (value: unknown, format?: string) => {
      if (format === 'uppercase' && typeof value === 'string') {
        return value.toUpperCase();
      }

      if (value instanceof Date) {
        return formatDate(value, format || dateFormatForUI);
      }

      return value as string;
    },
  },
};

export default i18nConfig;
